import React from 'react';
import { logout } from '../actions/UsuarioActions';
import { connect } from 'react-redux';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
    };
    this.dropdownRef = React.createRef();
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }

  handleOutsideClick(e) {
    if (this.dropdownRef.current && !this.dropdownRef.current.contains(e.target)) {
      this.setState({ dropdownOpen: false });
    }
  }

  logout() {
    localStorage.clear();
    this.props.logout();
  }

  getInitials(nome) {
    if (!nome) return 'U';
    const parts = nome.trim().split(' ');
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  toggleSidebar() {
    if (window.innerWidth <= 767) {
      document.body.classList.toggle('sidebar-open');
    } else {
      // Dispara evento para o Menu sincronizar o estado
      window.dispatchEvent(new CustomEvent('alpha-toggle-sidebar'));
    }
  }

  render() {
    const { usuario } = this.props;
    const { dropdownOpen } = this.state;
    const nome = usuario ? usuario.nome : '';
    const initials = this.getInitials(nome);

    return (
      <header className="alpha-header">
        {/* Navbar */}
        <nav className="alpha-navbar">
          {/* Hamburger */}
          <button
            className="alpha-sidebar-toggle"
            onClick={this.toggleSidebar.bind(this)}
            aria-label="Toggle menu"
          >
            <span className="alpha-bar"></span>
            <span className="alpha-bar"></span>
            <span className="alpha-bar"></span>
          </button>

          {/* Spacer */}
          <div style={{ flex: 1 }} />

          {/* Right actions */}
          <div className="alpha-nav-actions">

            {/* User dropdown */}
            <div className="alpha-user-dropdown" ref={this.dropdownRef}>
              <button
                className="alpha-user-trigger"
                onClick={() => this.setState({ dropdownOpen: !dropdownOpen })}
                aria-expanded={dropdownOpen}
              >
                <div className="alpha-avatar">{initials}</div>
                <span className="alpha-user-name">{nome}</span>
                <svg className={`alpha-chevron ${dropdownOpen ? 'open' : ''}`} width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>

              {dropdownOpen && (
                <div className="alpha-dropdown-menu">
                  <div className="alpha-dropdown-header">
                    <div className="alpha-avatar alpha-avatar-lg">{initials}</div>
                    <div>
                      <div className="alpha-dropdown-name">{nome}</div>
                      <div className="alpha-dropdown-role">
                        {usuario && usuario.tipo ? usuario.tipo.charAt(0).toUpperCase() + usuario.tipo.slice(1) : 'Usuário'}
                      </div>
                    </div>
                  </div>
                  <div className="alpha-dropdown-divider" />
                  <button
                    className="alpha-dropdown-item alpha-dropdown-logout"
                    onClick={this.logout.bind(this)}
                  >
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                      <polyline points="16 17 21 12 16 7"/>
                      <line x1="21" y1="12" x2="9" y2="12"/>
                    </svg>
                    Sair
                  </button>
                </div>
              )}
            </div>
          </div>
        </nav>
      </header>
    );
  }
}

const mapStateToProps = (state) => ({
  usuario: state.usuario.autenticado,
});

export default connect(mapStateToProps, { logout })(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js